(function(rediretBanner) {
    var recalculateStickyElements = function() {
        if (Waypoint) {
            // Showing/hiding the banner will push down some sticky elements using Waypoint. Refresh all when this happens.
            setTimeout(function() {
                // setTimeout to wait for the elements to be rerendered after css class change so Waypoints can get the latest element position
                Waypoint.refreshAll();
            }, 0);
        }
    };
    if (rediretBanner) {
        document.getElementById('i18n-redirect-close-button').addEventListener('click', function(event) {
            event.preventDefault();
            rediretBanner.classList.remove('i18n-redirect-banner--shown');

            recalculateStickyElements();

            localStorage.setItem('i18n-redirect-banner-dismissed', Date.now());
        });

        var dismissed = localStorage.getItem('i18n-redirect-banner-dismissed');
        var ttl = 30 * 86400 * 1000;

        if (dismissed < (Date.now() - ttl)) {
            rediretBanner.classList.add('i18n-redirect-banner--shown');

            recalculateStickyElements();
        }
    }
})(document.getElementById('i18n-redirect-banner'));